// extracted by mini-css-extract-plugin
export default {"CreateLocalizationKeyContent":"CreateLocalizationKeyContent_CreateLocalizationKeyContent__+Xun6"};